export enum ReportStatusTypes {
  Active = 'active',
  Archived = 'archived',
  CompleteDraft = 'complete_draft',
  Countersigning = 'countersigning',
  Expired = 'expired',
  IncompleteDraft = 'incomplete_draft',
  MoveOutCompleteDraft = 'move_out_complete_draft',
  MoveOutCountersigning = 'move_out_countersigning',
  MoveOutExpired = 'move_out_expired',
  MoveOutIncompleteDraft = 'move_out_incomplete_draft',
  MoveOutSentForSigning = 'move_out_sent_for_signing',
  MoveOutSentCompleteDraft = 'move_out_sent_complete_draft',
  MoveOutSentIncompleteDraft = 'move_out_sent_incomplete_draft',
  MoveOutSignedByTenant = 'move_out_signed_by_tenant',
  MoveOutSigningCompleted = 'move_out_signing_completed',
  SentCompleteDraft = 'sent_complete_draft',
  SentForSigning = 'sent_for_signing',
  SentIncompleteDraft = 'sent_incomplete_draft',
  SignedByTenant = 'signed_by_tenant',
  SigningCompleted = 'signing_completed',
  TenantCompleteDraft = 'tenant_complete_draft',
  TenantIncompleteDraft = 'tenant_incomplete_draft',
  Terminated = 'terminated',
}

export const statusMap = {
  [ReportStatusTypes.Active]: 'ACTIVE',
  [ReportStatusTypes.CompleteDraft]: 'DRAFT COMPLETED',
  [ReportStatusTypes.Countersigning]: 'COUNTERSIGNING',
  [ReportStatusTypes.Expired]: 'EXPIRED',
  [ReportStatusTypes.IncompleteDraft]: 'DRAFT INCOMPLETE',
  [ReportStatusTypes.MoveOutCompleteDraft]: 'DRAFT COMPLETED',
  [ReportStatusTypes.MoveOutCountersigning]: 'COUNTERSIGNING',
  [ReportStatusTypes.MoveOutExpired]: 'EXPIRED',
  [ReportStatusTypes.MoveOutIncompleteDraft]: 'DRAFT INCOMPLETE',
  [ReportStatusTypes.MoveOutSentForSigning]: 'SIGNING IN PROGRESS',
  [ReportStatusTypes.MoveOutSentCompleteDraft]: 'DRAFT COMPLETED',
  [ReportStatusTypes.MoveOutSentIncompleteDraft]: 'DRAFT INCOMPLETE',
  [ReportStatusTypes.MoveOutSignedByTenant]: 'SIGNING IN PROGRESS',
  [ReportStatusTypes.MoveOutSigningCompleted]: 'SIGNING COMPLETED',
  [ReportStatusTypes.SentCompleteDraft]: 'DRAFT COMPLETED',
  [ReportStatusTypes.SentForSigning]: 'SIGNING IN PROGRESS',
  [ReportStatusTypes.SentIncompleteDraft]: 'DRAFT INCOMPLETE',
  [ReportStatusTypes.SignedByTenant]: 'SIGNING IN PROGRESS',
  [ReportStatusTypes.SigningCompleted]: 'SIGNING COMPLETED',
  [ReportStatusTypes.TenantCompleteDraft]: 'IN PROGRESS',
  [ReportStatusTypes.TenantIncompleteDraft]: 'IN PROGRESS',
  [ReportStatusTypes.Terminated]: 'CANCELED',
};

export const participantStatusMap = {
  [ReportStatusTypes.Active]: 'ACTIVE',
  [ReportStatusTypes.CompleteDraft]: 'DRAFT COMPLETED',
  [ReportStatusTypes.Countersigning]: 'COUNTERSIGNING',
  [ReportStatusTypes.Expired]: 'EXPIRED',
  [ReportStatusTypes.IncompleteDraft]: 'DRAFT INCOMPLETE',
  [ReportStatusTypes.MoveOutCompleteDraft]: 'DRAFT COMPLETED',
  [ReportStatusTypes.MoveOutCountersigning]: 'COUNTERSIGNING',
  [ReportStatusTypes.MoveOutExpired]: 'EXPIRED',
  [ReportStatusTypes.MoveOutIncompleteDraft]: 'DRAFT INCOMPLETE',
  [ReportStatusTypes.MoveOutSentForSigning]: 'SIGNING IN PROGRESS',
  [ReportStatusTypes.MoveOutSentCompleteDraft]: 'DRAFT COMPLETED',
  [ReportStatusTypes.MoveOutSentIncompleteDraft]: 'DRAFT INCOMPLETE',
  [ReportStatusTypes.MoveOutSignedByTenant]: 'SIGNING IN PROGRESS',
  [ReportStatusTypes.MoveOutSigningCompleted]: 'SIGNING COMPLETED',
  [ReportStatusTypes.SentCompleteDraft]: 'SIGNING CANCELED',
  [ReportStatusTypes.SentForSigning]: 'SIGNING IN PROGRESS',
  [ReportStatusTypes.SentIncompleteDraft]: 'SIGNING CANCELED',
  [ReportStatusTypes.SignedByTenant]: 'SIGNING IN PROGRESS',
  [ReportStatusTypes.SigningCompleted]: 'SIGNING COMPLETED',
  [ReportStatusTypes.TenantCompleteDraft]: 'DRAFT COMPLETED',
  [ReportStatusTypes.TenantIncompleteDraft]: 'DRAFT INCOMPLETE',
  [ReportStatusTypes.Terminated]: 'CANCELED',
};

export const statusTagAppearanceMap = {
  [ReportStatusTypes.Active]: 'success',
  [ReportStatusTypes.CompleteDraft]: 'warning',
  [ReportStatusTypes.Countersigning]: 'error',
  [ReportStatusTypes.Expired]: 'gray',
  [ReportStatusTypes.IncompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutCompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutCountersigning]: 'error',
  [ReportStatusTypes.MoveOutExpired]: 'gray',
  [ReportStatusTypes.MoveOutIncompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutSentForSigning]: 'aqua',
  [ReportStatusTypes.MoveOutSentCompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutSentIncompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutSignedByTenant]: 'aqua',
  [ReportStatusTypes.MoveOutSigningCompleted]: 'success',
  [ReportStatusTypes.SentCompleteDraft]: 'warning',
  [ReportStatusTypes.SentForSigning]: 'aqua',
  [ReportStatusTypes.SentIncompleteDraft]: 'warning',
  [ReportStatusTypes.SignedByTenant]: 'aqua',
  [ReportStatusTypes.SigningCompleted]: 'success',
  [ReportStatusTypes.TenantCompleteDraft]: 'info',
  [ReportStatusTypes.TenantIncompleteDraft]: 'info',
  [ReportStatusTypes.Terminated]: 'gray',
};

export const statusTagToneMap = {
  [ReportStatusTypes.Active]: 'success',
  [ReportStatusTypes.CompleteDraft]: 'warning',
  [ReportStatusTypes.Countersigning]: 'critical',
  [ReportStatusTypes.Expired]: 'gray',
  [ReportStatusTypes.IncompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutCompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutCountersigning]: 'error',
  [ReportStatusTypes.MoveOutExpired]: 'gray',
  [ReportStatusTypes.MoveOutIncompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutSentForSigning]: 'aqua',
  [ReportStatusTypes.MoveOutSentCompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutSentIncompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutSignedByTenant]: 'aqua',
  [ReportStatusTypes.MoveOutSigningCompleted]: 'success',
  [ReportStatusTypes.SentCompleteDraft]: 'warning',
  [ReportStatusTypes.SentForSigning]: 'aqua',
  [ReportStatusTypes.SentIncompleteDraft]: 'warning',
  [ReportStatusTypes.SignedByTenant]: 'aqua',
  [ReportStatusTypes.SigningCompleted]: 'success',
  [ReportStatusTypes.TenantCompleteDraft]: 'info',
  [ReportStatusTypes.TenantIncompleteDraft]: 'info',
  [ReportStatusTypes.Terminated]: 'gray',
};

export const participantStatusTagAppearanceMap = {
  [ReportStatusTypes.Active]: 'success',
  [ReportStatusTypes.CompleteDraft]: 'warning',
  [ReportStatusTypes.Countersigning]: 'error',
  [ReportStatusTypes.Expired]: 'gray',
  [ReportStatusTypes.IncompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutCompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutIncompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutCountersigning]: 'error',
  [ReportStatusTypes.MoveOutExpired]: 'gray',
  [ReportStatusTypes.MoveOutSentForSigning]: 'aqua',
  [ReportStatusTypes.MoveOutSentCompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutSentIncompleteDraft]: 'warning',
  [ReportStatusTypes.MoveOutSignedByTenant]: 'aqua',
  [ReportStatusTypes.MoveOutSigningCompleted]: 'success',
  [ReportStatusTypes.SentCompleteDraft]: 'gray',
  [ReportStatusTypes.SentForSigning]: 'aqua',
  [ReportStatusTypes.SentIncompleteDraft]: 'gray',
  [ReportStatusTypes.SignedByTenant]: 'aqua',
  [ReportStatusTypes.SigningCompleted]: 'success',
  [ReportStatusTypes.TenantCompleteDraft]: 'warning',
  [ReportStatusTypes.TenantIncompleteDraft]: 'warning',
  [ReportStatusTypes.Terminated]: 'gray',
};
